// Whether a DE2 field is empty, mirroring each control's own currentValue.

import { DE2SuggestibleField } from './de2SuggestibleFields';
import { isFormValueEmpty } from 'concepts/AutoDocExtraction/outstandingSuggestions';
import { BlockRecords } from 'concepts/Extraction/BlocksData';
import { Factory } from 'concepts/Extraction/Blocks/factory';

export const isDE2FieldEmpty = (
  { block }: DE2SuggestibleField,
  values: BlockRecords
): boolean => {
  const value = values[block.id]?.value;

  // Falls back to the generic isFormValueEmpty when the block type has no check.
  return Factory(block).isEmpty?.(value) ?? isFormValueEmpty(value);
};
